import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import 'dayjs/locale/pt-br';


export default function SelectLogsStart({ ...props }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        label="Início"
        slotProps={{size:"small"}}
        renderInput={(params) => <TextField  {...params} />}
        {...props}
      />
    </LocalizationProvider>
  );
}
